var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6918",
    "data-name": "Groupe 6918",
    transform: "translate(-577 -400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(577 400)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-3957.852-1177.852v-18.3h-18.3A3.853,3.853,0,0,1-3980-1200a3.852,3.852,0,0,1,3.852-3.852h18.3v-18.3A3.853,3.853,0,0,1-3954-1226a3.852,3.852,0,0,1,3.852,3.853v18.3h18.3A3.852,3.852,0,0,1-3928-1200a3.852,3.852,0,0,1-3.852,3.853h-18.3v18.3A3.852,3.852,0,0,1-3954-1174,3.853,3.853,0,0,1-3957.852-1177.852Z",
    transform: "translate(4564 1633)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTemplate);
export default __webpack_public_path__ + "static/media/addTemplate.ecf72ad6e0d757f9f1eff4bed621643f.svg";
export { ForwardRef as ReactComponent };